module.exports = __webpack_public_path__ + "assets/images/match-field-sponsor-sides-heineken.20c65916fbe2ca73a037d03f52915180.png";